enum EnvTypes {
  production = "production",
  STAGE = "STAGE",
  QA_01 = "QA_01",
  DEV_NEXT = "DEV_NEXT",
  DEMO = "DEMO",
}

interface Configuration {
  HITT_URL: Location | string;
  WDT_WB_URL: Location | string;
  SSO_ENABLED?: string | undefined;
  ASSET_URL: Location | string;
}

interface TConfig {
  production: Configuration;
  STAGE: Configuration;
  QA_01: Configuration;
  DEV_NEXT: Configuration;
  DEMO: Configuration;
}

export const ENVIRONMENT_CONFIGS: TConfig = {
  [EnvTypes.production]: {
    HITT_URL: "https://hitt.lwtears.com/login",
    WDT_WB_URL: "https://production-whiteboard.lwtears.com/#/",
    ASSET_URL: "https://dtt-content.s3.amazonaws.com",
  },
  [EnvTypes.STAGE]: {
    HITT_URL: "https://stage-hitt.lwtears.com/login",
    WDT_WB_URL: "https://stage-whiteboard.lwtears.com/#/",
    ASSET_URL: "https://dtt-content.s3.amazonaws.com",
  },
  [EnvTypes.QA_01]: {
    HITT_URL: "https://qa01-hitt.lwtears.com/login",
    WDT_WB_URL: "https://qa02-whiteboard.lwtears.com/#/",
    ASSET_URL: "https://dtt-content.s3.amazonaws.com",
  },
  [EnvTypes.DEV_NEXT]: {
    HITT_URL: "https://dev-next-hitt.lwtears.com/login",
    WDT_WB_URL: "https://dev-next-whiteboard.lwtears.com/#/",
    ASSET_URL: "https://dtt-content.s3.amazonaws.com",
  },
  [EnvTypes.DEMO]: {
    HITT_URL: "https://demo-idtt.lwtears.com/login",
    WDT_WB_URL: "https://demo-idtt.lwtears.com/login",
    ASSET_URL: "https://dtt-content.s3.amazonaws.com",
  },
};

const getConfig = (env: EnvTypes): Configuration => {
  return ENVIRONMENT_CONFIGS[env];
};

const getSSOEnabled = (SSO_ENABLED) => ({
  SSO_ENABLED,
});

export default {
  ...getSSOEnabled(process.env.SSO_ENABLED),
  ...getConfig(process.env.REACT_APP_BUILD_ENV as EnvTypes),
} as Configuration;
